$(document).ready(function() {
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})
});


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/bootstrap-tooltip-init.js